$(function(){
  var girlNameToId={};
    function prepareGirlNameId(){
        var i;
        for(i in _girlImgNames){
            girlNameToId[_girlImgNames[i]]=intval(i);
        }
    }
    prepareGirlNameId();
    $.fn.girlProfile=function(options){
        var methods={};
        var html_type={
            "big":
            '<div class="photo"></div>'+
            '<div class="level">'+
            '<div class="in"></div>'+

            '</div>'+
            '<div class="busyBar">'+
            '<div class="fillWrap">'+
            '<div class="fill"></div>'+
            '<div class="flexColumnCenterAround fourDirection">'+
            '<div class="text">'+
            '<div class="shOne time timeJS"></div>'+
            '</div>'+
            '</div>'+
            '</div>'+
            '</div>',
            "small":
            '<div class="photo"></div>'+
            '<div class="border1"></div>'+
            '<div class="border2"></div>'+
            '<div class="level">'+
            '<div class="in"></div>'+
            '</div>',
            "medium":
            '<div class="photo"></div>'+
            '<div class="border"></div>'+
            '<div class="level">'+
            '<div class="in"></div>'+
            '</div>'+
            '<div class="girlName">'+
            '<div class="in"></div>'+
            '</div>'+
            '<div class="busyBar">'+
            '<div class="fillWrap">'+
            '<div class="fill"></div>'+
            '<div class="busyClock"></div>'+
            '<div class="textWrap">'+
            '<div class="text">'+
            '<div class="time timeJS"></div>'+
            '</div>'+
            '</div>'+
            '</div>'+
            '</div>',

        };
        function init(th,set){

            function timerEnd(th){
                th.find(".busyBar").hide();
                th.find(".busyBar .fill").beltTimer("clear");
                th.removeClass("unable");
            }
            var girl_data=th.data(),i,row_keys=["level","busy_start","busy_end","girl_id"];
            if(typeof set.girlArr.girl_id=="undefined"){
                for(i in row_keys){
                    girl_data[row_keys[i]]=intval(girl_data[row_keys[i]]);
                }
            }
            else{
                girl_data=copyObj(set.girlArr);
                var arr={},i;
                for(i in girl_data){
                    arr["data-"+i]=girl_data[i];
                }
                th.attr(arr).addClass(set.size);
            }

            var html=html_type[set["size"]];
            var girlImageName=$.takeGirlImage(girl_data.girl_id);
            html=$("<div>"+html+"</div>").find(".level>.in").html(girl_data.level).end()
                .find(".time.timeJS").addClass("timeJSGirlProf"+girl_data.girl_id).end()
                .find(".photo").css("background-image",("url("+_IMG_SERV+"/gfx/girls/"+girlImageName+"/profile.png"+$.takeGirlVersion(girl_data.girl_id)+")")).end()
                .find(".girlName .in").html(girl_data.name_str).end().
                html();
            th.html("").append(html);

            if(girl_data.busy_end>getCurrentTime()){
                var time_cur=getCurrentTime();
                th.find(".busyBar .fill").beltTimer(time_cur-girl_data.busy_start,girl_data.busy_end-time_cur,girl_data.busy_end);
                th.addClass('unable');
                th.find(".busyBar").show();
                _timerManager.addTimer(".timeJSGirlProf"+girl_data.girl_id,girl_data.busy_end,1,function(){
                    timerEnd(th);
                });

            }
            else{
                timerEnd(th);
            }
        }

        var last_this=$(this);
        var arg =Array.prototype.slice.call(arguments,1);
        return this.filter(".girlProfile").each(function(){
            var $this = $(this);
            if(methods[options]){
                arg.unshift($this);
                return methods[options].apply($this,arg);
            }
            else if (typeof options === 'object' || !options){
                var data = $this.data("girlProf");
                if(!data){
                    data = $.extend( {
                        "size":"big",
                        "girlArr":[],//set here on in div

                    }, options);
                }
                else{
                    data = $.extend(data, options);
                }
                $this.data("girlProf", data);
                init($this,data);



                return;
            }
            else{
                $.error('myPageSelector: no method: '+ options);
            }
        });
    };
    $.takeGirlImagePath=function(girl_id){
        return ""+_IMG_SERV+"/gfx/girls/"+$.takeGirlImage(girl_id)+"/profile.png"+$.takeGirlVersion(girl_id);
    };
    $.takeGirlImage=function(girl_id){
        if(typeof _girlImgNames[girl_id]!="undefined"){
            return _girlImgNames[girl_id];
        }
        else{
            return "blank";
        }
    };
    $.takeGirlId=function(girl_name){
        if(typeof girlNameToId[girl_name]!="undefined"){
            return girlNameToId[girl_name];
        }
        return 0;
    };
    $.takeGirlConf=function(girl_id,stat_name,mode){
        var girl_name=$.takeGirlImage(girl_id);
        if(mode=="special"){
            girl_name+="_special";
        }
        if(typeof _GIRL_CONF[girl_name][stat_name]!="undefined"){
            if(typeof _GIRL_CONF[girl_name][stat_name]=="object"){
                return copyObj(_GIRL_CONF[girl_name][stat_name]);
            }
            return _GIRL_CONF[girl_name][stat_name];
        }
        else{
            return {};
        }
    };
    $.takeGirlVersion=function(girl_id){
        if(typeof _girlPhpConf[girl_id]!="undefined" && typeof _girlPhpConf[girl_id].version != "undefined"){
            return "?"+_girlPhpConf[girl_id].version;
        }
        return "";
    };
    $.takeGirlNameReal=function(girl_id){
        if(typeof _girlPhpConf[girl_id]!="undefined"){
            return _girlPhpConf[girl_id].name;
        }
        return "";
    };
    $.takeGirlPositionConf=function(girl_id,level){
        var girl_name=$.takeGirlImage(girl_id);
        return copyObj(_GIRL_CONF[girl_name]["img"+level]);
    };
    $.takeGirlId=function(girl_name){
        if(typeof girlNameToId[girl_name]!="undefined"){
            return girlNameToId[girl_name];
        }
        return 0;
    };
});
var _GIRL_EXP={};




var _GIRL_CONF={
    blank:{
        img0:{width:0,height:0,left:0,top:0},
        img1:{width:0,height:0,left:0,top:0},
        img2:{width:0,height:0,left:0,top:0},
        img3:{width:0,height:0,left:0,top:0},
        img4:{width:0,height:0,left:0,top:0},
        img5:{width:0,height:0,left:0,top:0},
        img6:{width:0,height:0,left:0,top:0},
        img7:{width:0,height:0,left:0,top:0},
        img8:{width:0,height:0,left:0,top:0},
        img9:{width:0,height:0,left:0,top:0},
        img10:{width:0,height:0,left:0,top:0},
        eye10:0
    },
    ashley:{eye10:4},
    cherry:{eye10:1,anim10:{loop:1}},
    cindy:{eye10:4,anim10:{loop:1}},
    dora:{eye10:3},
    emma:{eye10:9,anim10:{loop:1}},
    frecly:{eye10:3},
    geeky:{eye10:2,anim10:{loop:1}},
    ice:{eye10:2,anim10:{loop:1}},
    indira:{eye10:6,anim10:{loop:1}},
    lola:{},
    pantress:{eye10:7,anim10:{waitOnLast:2000}},
    sanshi:{eye10:4},
    twins:{eye10:7,anim10:{loop:1}},
    victoria:{eye10:7},
    zoe:{eye10:8},
    maggie:{},
    winona:{},
    anya:{},
    linn:{},
    cupid:{},
    springn:{},
    springp:{},
    alice:{},
    soccer:{}
};

_GIRL_CONF["cherry"]["video_png"]={"2":{"belt":"top"},"3":{"belt":"top"}};
_GIRL_CONF["emma"]["video_png"]={"2":{"belt":"top"}};
_GIRL_CONF["victoria"]["video_png"]={"3":{"belt":"top"}};
_GIRL_CONF["zoe"]["video_png"]={"3":{"belt":"top"}};
_GIRL_CONF["sanshi"]["video_png"]={"3":{"belt":"top"}};
_GIRL_CONF["maggie"]["video_png"]={"1":{"belt":"top"}};
_GIRL_CONF["anya"]["video_png"]={"2":{"belt":"top"},"3":{"belt":"top"}};
_GIRL_CONF["linn"]["video_png"]={"3":{"belt":"top"}};

_GIRL_CONF["lola"]["img8"]={"center":[718,365]};
_GIRL_CONF["sanshi"]["img9"]={"center":[610,340]};
_GIRL_CONF["linn"]["img3"]={"center":[604,411]};

_GIRL_CONF['cupid']["anim_back"]={clips:4,width:390,loop:1,two_side:1,interval:220};
_GIRL_CONF['springn']["anim_back"]={clips:11,width:390,loop:1,interval:60};
_GIRL_CONF['springp']["anim_back"]={clips:11,width:390,loop:1,interval:60};

_GIRL_CONF['anya']['img2']={anim_add:{width:152,height:149,left:596,top:82,clips:10,animArr:[0,1,2,0,1,2,0,1,2,3,4,5,6,7,8,9,10]}};
_GIRL_CONF['anya']['img6']={anim_add:{width:155,height:151,left:429,top:110,clips:10,animArr:[0,1,2,0,1,2,0,1,2,3,4,5,6,7,8,9,10]}};
_GIRL_CONF['anya']['img8']={anim_add:{width:127,height:123,left:573,top:316,clips:10,animArr:[0,1,2,0,1,2,0,1,2,3,4,5,6,7,8,9,10]}};
